import React from "react";
import {Avatar, CircularProgress} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    avatar: {
        background: "linear-gradient(135deg, #6a2440 0%, #2a1220 100%)",
        color: theme.palette.primary.light,
        fontFamily: theme.typography.h1.fontFamily,
        fontWeight: 600,
        border: "1px solid rgba(255, 220, 232, 0.18)",
    },
}));

// A character's round portrait, their initial while there is none, a spinner while one is being drawn
export default function CharacterAvatar({name, portrait, size = 40, pending = false, className}: {
    name: string,
    portrait?: string,
    size?: number,
    pending?: boolean,
    className?: string,
}) {
    const classes = useStyles();
    const style = {width: size, height: size, fontSize: Math.round(size * 0.42)};
    return (
        <Avatar src={portrait || undefined} alt={name} style={style}
                className={`${classes.avatar} ${className || ''}`}>
            {pending ? <CircularProgress size={Math.round(size * 0.4)} color="primary"/> : (name || '?').charAt(0).toUpperCase()}
        </Avatar>
    );
}
